export default "/images/vendor/flag-icon-css/flags/1x1/se.svg?4984ae470ed69178af1dc26d6978f38f";